<template>
  <BoosterHeader />
  <div class="body-color">
    <div class="container">
      <div class="layout-container">
        <div v-if="showNav && !loading" class="sidebar" :class="{ 'collapsed-Sidebar': isCollapsed }">
          <BoosterNav v-model:collapsed="isCollapsed" />
        </div>
        <div class="content-area">
          <div class="main-content">
            <LoadingSpinnerWithBackground v-if="loading" />
            <div v-show="!loading">
              <router-view />
            </div>
          </div>
          <div class="footer">
            <BoosterFooter />
          </div>
        </div>
      </div>
    </div>
  </div>
  <PopupBox
    v-model:showPopupBox="popupState.showPopupBox"
    :content="popupState.content"
    :title="popupState.title"
    :okay="popupState.okay"
    :secondary-text="popupState.secondaryText"
    @primary-btn-action="popupState.primaryActionBtn"
    @secondary-btn-action="popupState.secondaryBtnAction" />
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router'; // <-- Import useRoute
import { popupStore } from '@/stores/PopupStore';
import BoosterHeader from '@/components/booster-header/BoosterHeader.vue';
import BoosterNav from '@/components/booster-nav/BoosterNav.vue';
import BoosterFooter from '@/components/booster-footer/BoosterFooter.vue';
import PopupBox from '@/components/popup-box/PopupBox.vue';
import { userStore } from '@/stores/UserStore';
import LoadingSpinnerWithBackground from '@/components/loading-spinner/LoadingSpinnerWithBackground.vue';

export default defineComponent({
  name: 'AdviserHubLayout',
  components: {
    BoosterHeader,
    BoosterNav,
    BoosterFooter,
    PopupBox,
    LoadingSpinnerWithBackground,
  },
  setup() {
    const isCollapsed = ref(false);
    const userStoreConst = userStore();
    const popupStoreConst = popupStore();
    const errorMessage = computed(() => userStoreConst.error);
    const popupState = computed(() => popupStoreConst.popupState);
    const loading = computed(() => userStoreConst.loading);

    const route = useRoute();
    const showNav = computed(() => route.name !== 'error'); // Hide nav on error page

    return {
      loading,
      errorMessage,
      popupState,
      showNav,
      isCollapsed
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/booster-styles.scss';

.body-color {
  background-color: $booster-background-gray;
}

.layout-container {
  display: flex;
  min-height: calc(100vh - 3.125rem);
}

.sidebar {
  width: 10.625rem;
  flex-shrink: 0;
  background: linear-gradient(270deg, $booster-sidebar-blue 0%, $booster-background-gray 100%);
  transition: width 0.3s ease;
  overflow: hidden;
  &.collapsed-Sidebar {
    width: 4rem;
  }
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  overflow-y: auto;
}
</style>
